export default __webpack_public_path__ + "static/media/newbie_project3.a5dc0d0c.jpg";